<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="left">
                <div class="swb-btn swb-btn-small" @click="updateImg">上传</div>
            </div>
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="setAttTag($event)">批量设置标签</button>
            </div>
        </div>
        <ul class="file-area input clearfix" v-if="servcWorkImgList.length > 0">
            <li class="file-content clearfix" :class="{'active': ids.indexOf(servcWorkImg.id) != -1}" v-for="(servcWorkImg, index) in servcWorkImgList" style="height: 100%">
                <el-checkbox v-if="servcWorkImg.merchantType == merchantType" v-model="checkBox[servcWorkImg.id]" @change="selectCheck(servcWorkImg.id)"></el-checkbox>
                <swb-file-item :trackKey="index" :fileName="servcWorkImg.fileName" :fileUuid="servcWorkImg.fileUuid" :fileBrowseUrl="servcWorkImg.fileBrowseUrl" :fileDownloadUrl="servcWorkImg.fileDownLoadUrl" :fileMd5="servcWorkImg.fileMd5"
                               :deletable="servcWorkImg.merchantType == merchantType" :onDelete="deleteFile"></swb-file-item>
                <el-input :title="servcWorkImg.desc" @input="changeDesc(index)" :disabled="true" v-model="servcWorkImg.desc" placeholder="文件名称不可多于50个字"></el-input>
                <div>{{servcWorkImg.ts}}</div>
                <div class="mt5"><i v-if="servcWorkImg.tagName != null" class="swb-tags swb-tags-success mr5">{{servcWorkImg.tagName}}</i></div>
                <div class="mt5" v-if="servcWorkImg.merchantType == merchantType">
                    <a class="swb-btn swb-btn-link" @click="enditImg(servcWorkImg.id)">编辑</a>
                    <a v-if="servcWorkImg.shared == false" class="swb-btn swb-btn-link ml10" @click="doShareImg(servcWorkImg.id, true)">共享</a>
                    <a v-if="servcWorkImg.shared == true" class="swb-btn swb-btn-link ml10" @click="doShareImg(servcWorkImg.id, false)">取消共享</a>
                </div>
            </li>
        </ul>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
        <swb-dt-popover ref="attPopoverRef" classes="popper-tabs">
            <swb-att-tag-list-for-select :attAspect="attAspect" :selectName="tagName" ref="swb_att_tag_list_for_select" @notity-attTag-comfirm="doAttTagConfirm" @notity-attTag-cancel="doAttTagCancel"></swb-att-tag-list-for-select>
        </swb-dt-popover>
    </div>
</template>
<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, getComnMerchantAttTag} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    //
    import servcDelivApi from '../../api/servcDeliv';
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);
    import SwbAttTagListForSelect from '../attTag/AttTagListForSelect'
    Vue.regist(SwbAttTagListForSelect);
    import SwbServcWorkVoucherImgSave from './ServcWorkVoucherImgSave'
    Vue.regist(SwbServcWorkVoucherImgSave);
    import SwbServcWorkImgFileUpdate from './ServcWorkImgFileUpdate'
    Vue.regist(SwbServcWorkImgFileUpdate);
    let bizTagObj = null;
    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "文件名称",
                "code": "desc",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "标签名称",
                "code": "tagName",
                "basic": true,
                "valueType": "String"
            }
        ]
    };
    export default {
        name: 'swb-servc-voucher-img-list',
        desc: '工单信息上传',
        props: ['id'],
        data: function () {

            return {
                // 资产图片
                servcWorkImgList: [],
                attAspect: getEnumInfoWith('retailerAttAspect', 'name', 'WorkVoucher').value,
                merchantType: getEnumInfoWith('merchantType', 'name', 'Retailer').value,
                selectTagId: null,
                bizTag: false,
                index: null,
                indexList: [],
                tagName: null,
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryConfig: searchConfigData,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                ids: [],
                checkBox: {}
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            bizTagObj = getComnMerchantAttTag();
            this.getServcWorkImgFileList();
        },
        methods: {
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getServcWorkImgFileList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                let self = this;
                this.pageNumber = val;
                this.getServcWorkImgFileList();
            },
            getServcWorkImgFileList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.voucherId = self.id;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                servcDelivApi.getServcWorkImgFileList(postData, function (result) {
                    if (result.type == "info") {
                        let servcWorkImgList = result.data.rows || [];
                        for (let i = 0; i < servcWorkImgList.length; i++) {
                            let servcWorkImg = servcWorkImgList[i];
                            let desc = servcWorkImg.desc;
                            let index = desc.lastIndexOf("_")
                            servcWorkImg.desc = desc.substring(0, index);
                            servcWorkImg.ts = desc.substring(index + 1);
                        }
                        self.servcWorkImgList = Utils.merge([], servcWorkImgList);
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        let checkBox = self.checkBox;
                        servcWorkImgList.forEach(function (item) {
                            if (checkBox[item.id] == null) {
                                checkBox[item.id] = false;
                            }
                        });

                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            deleteFile: function (index) {
                let self = this;
                let servcWorkImgList = this.servcWorkImgList;
                let servcWorkImg = servcWorkImgList[index.trackKey];
                let postData = {
                    id: servcWorkImg.id
                };
                let loading = MsgBox.loading();
                servcDelivApi.deleteServcWorkImgFile(postData, function (result) {
                    loading.close();
                    if (result.type == "info") {
                        MsgBox.success("刪除成功");
                        self.getServcWorkImgFileList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
                return false;
            },
            doShareImg: function(id, shared) {
                let self = this;
                let postData = {
                    id: id,
                    shared: shared
                };
                let loading = MsgBox.loading();
                servcDelivApi.updateSharedServcWorkImgFile(postData, function (result) {
                    loading.close();
                    if (result.type == "info") {
                        MsgBox.success("操作成功");
                        self.getServcWorkImgFileList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
                return false;
            },
            selectCheck: function (id) {
                let ids = this.ids || [];
                let checkBox = this.checkBox;
                if (ids.indexOf(id) >= 0) {
                    ids.remove(id);
                    checkBox[id] = false;
                } else {
                    ids.push(id);
                    checkBox[id] = true;
                }
                this.ids = Utils.merge([], ids);
                this.checkBox = checkBox;
            },

            setAttTag: function (event) {
                let ids = this.ids;
                if (ids.length <= 0) {
                    MsgBox.warning("请选择附件信息");
                    let popoverRef = this.$refs.attPopoverRef;
                    if (popoverRef != null) {
                        popoverRef.doClear();
                    }
                    return;
                }
                this.showPopoverRef(event);
            },
            showPopoverRef: function (event) {
                let curBtn = event.currentTarget;
                //
                let popoverRef = this.$refs.attPopoverRef;
                popoverRef.bindToReferer(
                    curBtn, 'click', {
                        showNow: true,
                        placement: 'bottom-start'
                    }
                )
            },
            doAttTagConfirm: function (data) {
                let self = this;
                let popoverRef = self.$refs.attPopoverRef;
                console.log(data);
                popoverRef.doClear();
                let ids = self.ids;
                let postData = {
                    ids: ids,
                    tagName: data
                };
                let loading = MsgBox.loading();
                servcDelivApi.updateServcWorkImgFileTagName(postData, function (result) {
                    loading.close();
                    if (result.type == "info") {
                        MsgBox.success("修改成功");
                        let checkBox = self.checkBox;
                        ids.forEach(function (id) {
                            checkBox[id] = false;
                        });
                        self.ids = Utils.merge([], []);
                        self.checkBox = checkBox;
                        self.getServcWorkImgFileList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },

            doAttTagCancel: function () {
                let popoverRef = this.$refs.attPopoverRef;
                popoverRef.doHide();
            },
            enditImg: function (id) {

                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '附件 - 编辑',
                    width: 600,
                    height: 450,
                    template: '<div class = "">' +
                    '<swb-servc-voucher-img-update :id="id" ref="swb_servc_voucher_img_update"></swb-servc-voucher-img-update>' +
                    '</div>',
                    data: {
                        id: id
                    },
                    okClicked: function () {
                        let resultData = this.$refs.swb_servc_voucher_img_update.getDlgResult() || {};
                        if (resultData.type === 'info') {
                            let servcWorkImg = resultData.data;
                            servcWorkImg.id = id;
                            let loading = MsgBox.loading();
                            servcDelivApi.updateServcWorkImgFile(servcWorkImg, function (result) {
                                loading.close();
                                if (result.type == "info") {
                                    MsgBox.success("修改成功");
                                    self.getServcWorkImgFileList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        } else {
                            MsgBox.warning(resultData.message);
                            return false;
                        }
                    }
                });
            },
            updateImg: function () {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '附件上传',
                    width: 800,
                    height: 650,
                    template: '<div class = "">' +
                    '<swb-servc-voucher-img-edit :count="count" ref="swb_servc_voucher_img_edit"></swb-servc-voucher-img-edit>' +
                    '</div>',
                    data: {
                        count: self.totalCount
                    },
                    okClicked: function () {
                        let resultData = this.$refs.swb_servc_voucher_img_edit.getDlgResult() || {};
                        if (resultData.type === 'info') {
                            let servcWorkVoucher = {};
                            servcWorkVoucher.id = self.id;
                            servcWorkVoucher.servcWorkImgFileList = resultData.data;
                            let loading = MsgBox.loading();
                            servcDelivApi.saveServcWorkImgFile(servcWorkVoucher, function (result) {
                                loading.close();
                                if (result.type == "info") {
                                    MsgBox.success("保存成功");
                                    self.getServcWorkImgFileList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        } else {
                            MsgBox.warning(resultData.message);
                            return false;
                        }
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherImgList.vue